import { useUpload } from '../../context/UploadContext';
import '../../styles/EditCase.css';

// Renders upload progress purely from UploadContext state — Firestore has
// nothing for these files yet, since the case's `files` array is only
// written once /case/finalize-upload completes for each one.
export default function UploadProgressPanel({ onStartExtraction }) {
    const { files, processError, retryFile, removeFile } = useUpload();

    const visibleFiles = files.filter((f) => f.status !== 'removed');
    const currentIndex = visibleFiles.findIndex(
        (f) => f.status === 'uploading' || f.status === 'stalled'
    );
    const current = currentIndex >= 0 ? visibleFiles[currentIndex] : null;

    return (
        <div className="upload-progress-panel">
            {current && (
                <div className="upload-progress-header">
                    Uploading file {currentIndex + 1} of {visibleFiles.length} — {current.percent}%
                </div>
            )}

            <ul className="upload-progress-list">
                {visibleFiles.map((file) => (
                    <li key={file.id} className={`upload-progress-row upload-progress-row--${file.status}`}>
                        <div className="upload-progress-row-main">
                            <span className="upload-progress-file-name" title={file.name}>{file.name}</span>
                            {file.status === 'done' ? (
                                <span className="upload-progress-check" aria-label="done">✓</span>
                            ) : (
                                <span className="upload-progress-percent">{file.percent}%</span>
                            )}
                        </div>

                        {file.status !== 'done' && file.status !== 'failed' && (
                            <div className="upload-progress-bar">
                                <div
                                    className="upload-progress-bar-fill"
                                    style={{ width: `${file.percent}%` }}
                                />
                            </div>
                        )}

                        {file.status === 'stalled' && (
                            <div className="upload-stall-warning">
                                Upload stalled — check your connection
                            </div>
                        )}

                        {file.status === 'failed' && (
                            <div className="upload-progress-failed">
                                <span className="upload-progress-error-message">
                                    {file.error || 'Upload failed'}
                                </span>
                                <div className="upload-progress-failed-actions">
                                    <button
                                        type="button"
                                        className="form-button"
                                        onClick={() => retryFile(file.id)}
                                    >
                                        Retry
                                    </button>
                                    <button
                                        type="button"
                                        className="form-button form-button-secondary"
                                        onClick={() => removeFile(file.id)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        )}
                    </li>
                ))}
            </ul>

            {processError && (
                <div className="stale-banner upload-process-error">
                    <div className="stale-banner-message">
                        Failed to start extraction. Your files finished uploading, but starting
                        extraction failed.
                    </div>
                    <button type="button" className="form-button" onClick={onStartExtraction}>
                        Start extraction
                    </button>
                </div>
            )}
        </div>
    );
}
